import { DictionariesEndpoint, Dictionary } from '@common/types';
import { apiInstance } from '@core/api/instance';
import { getAPIURL } from '@common/api/helpers';

export const TariffAPI: any = {
  operation: ({ dictionary = Dictionary.VehicleTariff }) => {
    return apiInstance().post(getAPIURL(dictionary, DictionariesEndpoint.getFormulaConstants));
  }
};
